export const MODEL_NUMBER_COLUMN_WIDTHS = {
	modelNumber: "14%",
	width: "14%",
	height: "14%",
	depth: "14%",
	minSize: "14%",
	avgSize: "14%",
	maxSize: "14%",
} as const
